import React from 'react';

// The list-side marker of a request whose named reviewer has dropped off the
// reviewer roster — they left the firm, or moved to a designation their stage
// does not call for. Nobody can sign such a request until the requester
// modifies it and picks again, so the row says so without having to be opened.
// The server sets `reviewerLapsed` on the in-flight rows it lists
// (routes/chosenReview.js); the detail page's ApprovalsCard names which stage
// and why.
const ReviewerLapsedNote = ({ when }) => {
  if (!when) return null;
  return (
    <span className="block mt-0.5 text-[10px] text-amber-700">Reviewer needs reassigning</span>
  );
};

export default ReviewerLapsedNote;
